export * from './doa-dashboard-details.component';

